import { useEffect, useState } from "react";
import { makeStyles } from "tss-react/mui";
import {
  DocumentPreview,
  MiInternalDrawer,
  MiTab,
} from "@miplatform/components";
import { IDocumentListItemResponse } from "@miplatform/types";
import { Box } from "@mui/material";
import { useCreateBidContext } from "../CreateBidContext";

export function BidDocumentViewer({ documentId }: IBidDocumentViewerProps) {
  const [currentTab, setCurrentTab] = useState("");
  const [selectedDoc, setSelectedDoc] =
    useState<IDocumentListItemResponse | null>(null);

  const { form, openDocumentViewer, setOpenDocumentViewer } =
    useCreateBidContext();
  const { watch } = form;
  const { documents } = watch();
  const { classes } = useStyles();

  useEffect(() => {
    if (openDocumentViewer && documents.length === 0) {
      setOpenDocumentViewer(false);
    }
    if (openDocumentViewer && documents.length > 0) {
      const doc = documents.find((d) => d.id === documentId) ?? documents[0];
      setCurrentTab(doc.id);
      setSelectedDoc(doc);
    }
  }, [openDocumentViewer, documents, documentId]);

  const tabs = documents.map((doc) => ({
    label: doc.category || "",
    value: doc.id,
  }));

  const handleTabChange = (tab: string) => {
    setCurrentTab(tab);
    const doc = documents.find((doc) => doc.id === tab) ?? null;
    setSelectedDoc(doc);
  };

  return (
    <MiInternalDrawer open={openDocumentViewer} width={600}>
      <Box className={classes.root}>
        <MiTab
          tabs={tabs}
          currentTab={currentTab}
          onTabChange={handleTabChange}
          isSecondary
        />
        <DocumentPreview selectedDocument={selectedDoc} />
      </Box>
    </MiInternalDrawer>
  );
}

const useStyles = makeStyles()((theme) => ({
  root: {
    flex: 1,
    borderLeft: `1px solid ${theme.palette.grey.accent}`,
  },
}));

interface IBidDocumentViewerProps {
  documentId?: string;
}
